module.exports = __webpack_public_path__ + "img/icon_1.b14a7b84.png";